import { CreditCardService } from '../../../../services/credit-card.service'

export async function getCreditCardInstallmentOptions(value) {
	let options = []
	if (value === 0) return options

	let response = await CreditCardService.GetInstallmentsOptions(value)
	const array = response.data

	if (array.length > 0) {
		array.forEach((element, index) => {
			let interest = element.installments * element.installmentValue - value
			let installmentValue = element.installmentValue.$toReais()
			let label =
				index == 0
					? `${installmentValue} à vista`
					: `${element.installments}x de
						${installmentValue} ${
							element.withInterest
								? '(Juros: ' + interest.$toReais() + ')'
								: ' sem juros'
					  }
						 `

			options.push({
				value: element.installments,
				label: label,
				interest,
			})
		})
	}
	return options
}
